import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Table } from 'react-bootstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DataTables from '../commonComponent/DataTable/DataTables';
import SweetAlert from 'sweetalert2';
import { URL_Start } from '../../../constant';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import Alert from "react-bootstrap/Alert";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PrintPDF from '../commonComponent/PrintPDF';
import EditToolTip from '../UI/ToolTips/EditToolTip';
import { CSVLink } from "react-csv";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { MultiSelect } from 'react-multi-select-component';
import '../../../pages/admin/react-multiselect.css';
import { Check } from 'react-feather';
import { array } from 'yup/lib/locale';
import Select from 'react-select';
import SampleToolTip from '../UI/ToolTips/SampleToolTip';
const DayEndPendingReport = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [downloadvisible, setDownloadVisible] = useState(false);
    const [crntPageNO, setCrntPageNO] = useState(0);
    const [users, setUsers] = useState([]);
    const [typeSelected, setTypeSelected] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [CSVData, setCSVData] = useState([]);
    const paginationOptions = {
        sizePerPage: 10, showTotal: false, firstPageText: 'First', prePageText: 'Back', nextPageText: 'Next', lastPageText: 'Last',
        onPageChange: (page, sizePerPage) => { setCrntPageNO(((page - 1) * sizePerPage)); }
    };
    const idFormatter = (cellData, rowData, rowIndex, extraData) => {
            return <React.Fragment>
                <div>
                    <span>{crntPageNO + rowIndex + 1}</span>
                </div>
            </React.Fragment>
        }

    const columns = [
        { dataField: '#', text: '#', editable: false, formatter: idFormatter, headerStyle: (colum, colIndex) => { return { width: '5%' }; } },
        { dataField: 'Name', text: 'User Name', editable: false },
        { dataField: 'Email', text: 'User Email', editable: false },
        { dataField: 'LastDayEndApplied', text: 'Last DayEnd Applied Date', editable: false },
        { dataField: 'LastBookingDate', text: 'Last Booking Date', editable: false }
    ];

    useEffect(() => {
        //GetUsersforDayendreports();
        BindGrid();
    }, [])

    const GetUsersforDayendreports = async () => {
        var glblArr = [];
        try {
            let url = URL_Start + 'reports/GetUsersforDayendreports/'
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data != null) {
                        var itmData = data.Data;
                        itmData.map((option) => { return glblArr.push({ 'value': option.Id, 'label': option.Value, 'disabled': false }); });
                        setUsers(glblArr);
                    }
                    else { setUsers([]); }
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }

    const formik = useFormik({
        initialValues: { reportuser: '' }
    });


    const handleSearch = async () => {
        if ((typeSelected == [] || typeSelected == null || typeSelected == undefined || typeSelected == "" || typeSelected.length == 0)) {
            SweetAlert.fire('Please select user');
            return false;
        }
        BindGrid();
    }
    const BindGrid = async () => {
        const ObjServiceCollection = {
            AccessUserId: localStorage.getItem('LoggedInUser'),
            UserId: typeSelected.length == 0 ? "" : typeSelected//reportsuser.current.value,

        };
        setIsLoading(true);
        let url = URL_Start + 'reports/getdayendpendings'
        await axios.post(url, ObjServiceCollection).then((response) => {
            const data = response.data;
            if (data.Success) {
                if (data.Data != null) {
                    setTableData(data.Data);
                }
                setIsLoading(false);
            }
            else { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }); setIsLoading(false); }
        }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } 
        setIsLoading(false); });
    }

    const ErrorFunction = async (ErrorCode) => {
        if (ErrorCode == "400") { SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" }); }
        else if (ErrorCode == "401") { SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" }); }
        else if (ErrorCode == "403") { SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" }); }
        else if (ErrorCode == "404") { SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" }); }
        else if (ErrorCode == "500") { SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" }); }
        else if (ErrorCode == "503") { SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" }); }
    }
    const TypeChangeHandler = (options) => { formik.values.reportuser = options.value; setTypeSelected(options.value); }
    const handleDownload = async () => {
        GetReportData();
    }
    const GetReportData = async () => {
        setDownloadVisible(false);
        const ObjServiceCollection = {
            AccessUserId: localStorage.getItem('LoggedInUser'),
            UserId: typeSelected.length == 0 ? "" : typeSelected//reportsuser.current.value,

        };
        try {
            let url = URL_Start + 'reports/getdayendpendings'
            await axios.post(url, ObjServiceCollection).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data != null && data.Data.length > 0) {
                        setDownloadVisible(true);
                        setCSVData(data.Data);
                        document.getElementById("csvdownload").click();
                    }
                    else { setCSVData([]); }
                }
            }).catch(function (error) { });
            setDownloadVisible(false);
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
        setIsLoading(false);
        setDownloadVisible(false);
    }
    return (
        <>
            <Breadcrumb title="DayEnd Pending" parent="Reports" />
            <Container fluid>
                {/* <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                                <Form.Row className='justify-content-center'>
                                    <Col md={6} >
                                        <Form.Group>
                                            <div id='selUser'>
                                                <Form.Label>Select User<span className='text-red'>*</span></Form.Label>
                                                <Select onChange={TypeChangeHandler}
                                                    options={users}
                                                    value={users.filter(function (x) { return x.value === typeSelected; })} />
                                            </div>
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} >
                                        <div className="searchButtonSec">
                                            <Button variant='primary' onClick={handleSearch}>Search</Button>
                                        </div>

                                    </Col>

                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row> */}
                <Row>
                    <Col md={10}>
                    </Col>
                    <Col md={2}>
                                <Button className='ml-2' variant='primary' onClick={GetReportData}>Download CSV</Button>
                                {
                                    downloadvisible &&
                                    <CSVLink data={CSVData} filename="DayEndPending.csv" target="_blank" id="csvdownload"></CSVLink>
                                }
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                            {
                                    isLoading ?
                                        <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                                        <>
                                            <DataTables keyField='Email' tableData={tableData} columns={columns} />
                                        </>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default DayEndPendingReport;